<template>
  <div class="view pa24">
    选择状态：
    <el-radio
      class="mr10"
      style="margin: 0"
      v-for="(item, index) in radioArr"
      :key="index"
      v-model="radioValue"
      :label="item.value"
      border
      >{{ item.text }}</el-radio
    >
    <el-button type="primary" @click="queryVerifyPageBusinessCard"
      >{{ $t('addedServices', 'search') }}</el-button
    >
    <div style="float: right">
      <el-button type="primary" @click="batchTejectAuditing"
        >{{ $t('addedServices', 'batchReject') }}</el-button
      >
      <el-button type="primary" class="ml20" @click="batchPassAuditing"
        >{{ $t('addedServices', 'batchPass') }}</el-button
      >
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSelectionChange="handleSelectionChange"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      clearName = 'demandProtuctsCheck'
      itemKey='verify'
      :total="total"
    >
      <template v-slot:table>
        <el-table-column type="selection" width="55" />
        <el-table-column
          type="index"
          align="center"
          :label="$t('addedServices', 'serialNumber')"
          show-overflow-tooltip
        />
        <el-table-column prop="createTime" align="center" :label="$t('addedServices', 'createTime')" >
           <template slot-scope="scope">
             {{scope.row.createTime | getDataTimeSec}}
           </template>
        </el-table-column>
        <el-table-column prop="companyName" align="center" :label="$t('addedServices', 'companyName')" />
        <el-table-column prop="position" align="center" :label="$t('addedServices', 'position')" />
        <el-table-column prop="name" align="center" :label="$t('addedServices', 'businessCardUser')" />
        <el-table-column align="center" prop="verify" :label="$t('addedServices', 'businessCardStatus')">
          <!--                    审核状态 0待审核 1 审核通过 2 审核不通过-->
          <template slot-scope="scope">
            {{
              scope.row.verify == 0
                ? $t('addedServices', 'pendingReviewStatus')
                : scope.row.verify == 1
                ? $t('addedServices', 'approved')
                : scope.row.verify == 2 && $t('addedServices', 'rejectedStatus')
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('addedServices', 'operation')" width="170">
          <template slot-scope="scope">
            <el-button
              @click="rejectAuditing(scope.row)"
              type="text"
              size="small"
              style="color: #fd634e"
              v-if="scope.row.verify == 0"
            >
              {{ scope.row.verify == 0 ? $t('addedServices', 'reject') : "---" }}
            </el-button>
            <customPopconfirm
              :confirm-button-text="$t('addedServices', 'confirm')"
              :cancel-button-text="$t('addedServices', 'cancel')"
              @confirm="verifyBusinessCard(scope.row)"
              v-if="scope.row.verify == 0"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('addedServices', 'confirmPassAudit')">
              <el-button slot="reference" type="text" class="ml10" size="small">
                {{ scope.row.verify == 0 && $t('addedServices', 'pass') }}
              </el-button>
            </customPopconfirm>
            <customPopconfirm
              :confirm-button-text="$t('addedServices', 'confirm')"
              :cancel-button-text="$t('addedServices', 'cancel')"
              @confirm="offBusinessCard(scope.row)"
              v-if="scope.row.verify == 1"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('addedServices', 'confirmDelete')">
              <el-button type="text" slot="reference" size="small">
                {{ $t('addedServices', 'delete') }}
              </el-button>
            </customPopconfirm>
            <el-button type="text" size="small" v-if="scope.row.verify == 2">
              {{ scope.row.reasonNote }}
            </el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      :title="$t('addedServices', 'rejectReason')"
      width="400px"
      ref="form"
      :modal-append-to-body="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="name">
          <el-input v-model="ruleForm.name" type="textarea" rows="2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('addedServices', 'cancel') }}</el-button>
        <el-button class="btncss" @click="submitData()">{{ $t('addedServices', 'confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';
import {
  queryVerifyPageBusinessCard,
  verifyBusinessCard,
  offBusinessCard,
  batchVerifyBusinessCard,
} from "@/api/addedServices";
export default {
  mixins: [i18nMixin],
  data() {
    return {
      radioValue: "",
      radioArr: [
        { text: this.$t('addedServices', 'all'), value: "" },
        { text: this.$t('addedServices', 'pendingReview'), value: "0" },
        { text: this.$t('addedServices', 'rejected'), value: "2" },
        { text: this.$t('addedServices', 'published'), value: "1" },
      ],
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      dialogFormVisible: false,
      form: {},
      ruleForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: this.$t('addedServices', 'pleaseEnterRejectReason'), trigger: "blur" }],
      },
      multipleSelection: [],
      isMultipleSelection: false,
    };
  },
  components: {
    commonTable,
    customPopconfirm
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    this.queryVerifyPageBusinessCard();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryVerifyPageBusinessCard();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryVerifyPageBusinessCard();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async queryVerifyPageBusinessCard() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        verify: this.radioValue,
        isPublic: 1,
      };
      try {
        this.loading = true;
        const result = await queryVerifyPageBusinessCard(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    /**@method 通过审核 */
    async verifyBusinessCard(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.verify = 1;
      await verifyBusinessCard(data);
      await this.queryVerifyPageBusinessCard();
    },
    /**@method 驳回 */
    rejectAuditing(row) {
      this.dialogFormVisible = true;
      this.form = row;
    },
    async submitData() {
      if (this.isMultipleSelection) {
        let data = {
          cards: this.multipleSelection.map((item) => item.cardId),
          verify: 2,
          isPublic: 0,
          reasonNote: this.ruleForm.name,
        };
        await batchVerifyBusinessCard(data);
        this.dialogFormVisible = false;
        this.queryVerifyPageBusinessCard();
      } else {
        let data = JSON.parse(JSON.stringify(this.form));
        data.verify = 2;
        data.reasonNote = this.ruleForm.name;
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            try {
              await verifyBusinessCard(data);
              this.dialogFormVisible = false;
              await this.queryVerifyPageBusinessCard();
            } catch (error) {
              console.log(error);
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    /**@method 删除 */
    async offBusinessCard(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.verify = 1;
      try {
        await offBusinessCard(data);
        this.queryVerifyPageBusinessCard();
      } catch (error) {
        console.log(error);
      }
    },
    /**@method 批量通过 */
    async batchPassAuditing() {
      if (this.multipleSelection.length != 0) {
        let data = {
          verify: 1,
          cards: this.multipleSelection.map((item) => item.cardId),
        };
        await batchVerifyBusinessCard(data);
        this.queryVerifyPageBusinessCard();
      } else {
        this.$message({
          message: this.$t('addedServices', 'pleaseSelectDemand'),
          type: "warning",
        });
      }
    },
    /**@method 批量驳回 */
    batchTejectAuditing() {
      if (this.multipleSelection.length != 0) {
        
        this.isMultipleSelection = true;
        this.dialogFormVisible = true;
      } else {
        this.$message({
          message: this.$t('addedServices', 'pleaseSelectDemand'),
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>